import { useDispatch, useSelector } from "react-redux";
import "./chatBoxLight.css";
import "./chatBoxDark.css";
import DopDownEditText from "../dopDownEditText/dopDownEditText";
import ChatContainer from "../chatContainer/chatContainer";
import EmojiDropDownPicker from "../emojiPicker/emojiPicker";
import { useEffect, useRef, useState } from "react";
import UploadFileItems from "../uploadFileItems/uploadFileItems";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { getMessageItem } from "../../../../redux/reducer/getMessageItem/action/action";
import { enabledAll } from "../../../../redux/reducer/otherMenuOptionsForMessageItems/action/action";
import UploadFileItemsEdit from "../uploadFileItems/uploadFileItemsEdit";
import ReplaceSelectorForChatBody from "../replaceSelectorForChatBody/replaceSelectorForChatBody";
import sockets from "../../../../socket/socket";
const socket = sockets;
export default function ChatBox({ isTrade }) {
  const getDarkModoe = useSelector((darkModes) => darkModes);
  const [value, setValue] = useState("");
  const [height, setHeight] = useState("20px");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [editfiles, setEditFiles] = useState([]);
  const [searchParams] = useSearchParams();
  const chatID = searchParams.get("chatID");
  const dispatch = useDispatch();
  const textareaRef = useRef(null);
  // для обновления сокета
  const [chooseWokers, setChooseWokers] = useState([]);
  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
  const getMessageItems = useSelector(messageItem => messageItem);

  const otherMenuOptionsForMessageItemsReducer = useSelector(
    (otherMenuOptionsForMessageItemsReducer) =>
      otherMenuOptionsForMessageItemsReducer.otherMenuOptionsForMessageItemsReducer
  );
  const handleChange = (event) => {
    const textareaLineHeight = 24; // Adjust this value based on your textarea's line height
    const previousRows = event.target.rows;
    event.target.rows = 1; // Reset rows to 1 to properly calculate scroll height
    const currentRows = Math.ceil(
      event.target.scrollHeight / textareaLineHeight
    );
    event.target.rows = currentRows;
    setHeight(`${currentRows * textareaLineHeight}px`);
    setValue(event.target.value);

    // Adjust the scroll position to keep the cursor visible when typing near the bottom
    if (currentRows > previousRows) {
      event.target.scrollTop = event.target.scrollHeight;
    }
  };

  useEffect(() => {
    if (value && value.length === 0 || value == "") {
      // Добавлена проверка value на существование
      setHeight("20px");
    }
  }, [value]);
  // здесь мы добавляем файлы в состоянии
  const handleFileChange = (event) => {
    setSelectedFiles([...selectedFiles, ...event.target.files]);
    console.log(selectedFiles);
  };
  // из состояния удаляем файл через индексацию
  const handleDelete = (index) => {
    const updatedFiles = selectedFiles.filter((file, i) => i !== index);
    setSelectedFiles(updatedFiles);
  };
  const handleDeleteFile = (index) => {
    const updatedFiles = editfiles.filter((file, i) => i !== index);
    setEditFiles(updatedFiles);
  };
  // отправляем данные на сервер чтобы создать сообщение
  function scrollToBottom() {
    const chatBodyChildCont = document.getElementById("chatBodyChildCont");
    if (chatBodyChildCont) {
      chatBodyChildCont.scrollTop = chatBodyChildCont.scrollHeight;
    }
  }

  const handleCreateMessage = () => {
    try {
      if (selectedFiles.length > 0 || value) {
        const formData = new FormData();
        selectedFiles.forEach((file) => {
          formData.append("file", file);
        });
        formData.append("messageText", value);
        formData.append("chatID", chatID);

        axios
          .post("/creatMessageItem/api", formData)
          .then((response) => {
            axiosGetWorkers("/getCurrendCompanyWorkers/api");
            setValue("");
            setSelectedFiles([]);
            if (getMessageItems.userReducerMessageItem.loading == false) {
              setTimeout(() => {
                scrollToBottom();
              }, 2000);
            }


          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    } catch (error) {
      console.error("Error:", error);
      throw new Error("ошибка при создании сообщения"); // Генерация ошибки при возникновении ошибки запроса
    }
  };

  const handleEdit = () => {
    console.log(otherMenuOptionsForMessageItemsReducer.data);
    try {
      if (selectedFiles.length > 0 || value) {
        const formData = new FormData();
        selectedFiles.forEach((file) => {
          formData.append("file", file);
        });
        formData.append("messageText", value);
        formData.append("chatID", chatID);
        formData.append("trade", false);
        formData.append(
          "data",
          JSON.stringify(otherMenuOptionsForMessageItemsReducer.data)
        );

        // Преобразование массива в JSON-строку и добавление её в FormData
        formData.append("AlreadyExistingFiles", JSON.stringify(editfiles));

        axios
          .put("/editCurrentPessage/api", formData)
          .then((response) => {
            console.log(response.data);
            console.log("Edited message successfully");
            axiosGetWorkers("/getCurrendCompanyWorkers/api");
            setValue("");
            setSelectedFiles([]);
            setEditFiles([]);
            scrollToBottom();
            dispatch(enabledAll());
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    } catch (error) {
      console.error("Error:", error);
      throw new Error("Ошибка при редактировании сообщения"); // Генерация ошибки при возникновении ошибки запроса
    }
  };

  useEffect(() => {

    if (otherMenuOptionsForMessageItemsReducer.editMessage) {
      if (otherMenuOptionsForMessageItemsReducer && otherMenuOptionsForMessageItemsReducer.data) {

        if (otherMenuOptionsForMessageItemsReducer.data.messageText) {
          setValue(otherMenuOptionsForMessageItemsReducer.data.messageText);

        } else {
          setValue("");
        }

        if (otherMenuOptionsForMessageItemsReducer.data.files && otherMenuOptionsForMessageItemsReducer.data.files.length > 0) {
          setEditFiles(otherMenuOptionsForMessageItemsReducer.data.files);

        }
      }
    }

  }, [otherMenuOptionsForMessageItemsReducer]);

  const handleSelection = () => {
    const textarea = textareaRef.current;
  };

  const editText = (e) => {
    const textarea = textareaRef.current;
    const startIndex = textarea.selectionStart;
    const endIndex = textarea.selectionEnd;
    if (startIndex !== endIndex) {
      const text = textarea.value;
      const selectedText = text.substring(startIndex, endIndex);

      // Вставляем символ * в начало и в конец выделенного текста в строке
      const newText =
        text.slice(0, startIndex) + e + selectedText + e + text.slice(endIndex);

      console.log("Текст с выделением:", newText);
      console.log("Индекс начала выделенного текста:", startIndex);
      console.log("Индекс конца выделенного текста:", endIndex);

      // Устанавливаем новое значение в textarea
      textarea.value = newText;
      setValue(newText);
    } else {
      console.log("Текст не выделен");
    }
  };

  const editTextLink = (e) => {
    const textarea = textareaRef.current;
    const startIndex = textarea.selectionStart;
    const endIndex = textarea.selectionEnd;
    if (startIndex !== endIndex) {
      const text = textarea.value;
      const selectedText = text.substring(startIndex, endIndex);

      // Вставляем символ * в начало и в конец выделенного текста в строке
      const newText =
        text.slice(0, startIndex) +
        "(" +
        selectedText +
        ")[]" +
        text.slice(endIndex);

      console.log("Текст с выделением:", newText);
      console.log("Индекс начала выделенного текста:", startIndex);
      console.log("Индекс конца выделенного текста:", endIndex);

      // Устанавливаем новое значение в textarea
      textarea.value = newText;
      setValue(newText);
    } else {
      console.log("Текст не выделен");
    }
  };

  const certainText = () => {
    const textarea = textareaRef.current;
    const startIndex = textarea.selectionStart;
    const endIndex = textarea.selectionEnd;

    let textareID = document.getElementById("textarea");
    textarea.focus();
    textarea.setSelectionRange(startIndex, endIndex);
  };

  const handleReply = async () => {
    try {
      if (selectedFiles.length > 0 || value) {
        const formData = new FormData();
        selectedFiles.forEach((file) => {
          formData.append("file", file);
        });
        formData.append("messageText", value);
        formData.append("chatID", chatID);
        formData.append("trade", false);
        formData.append(
          "messageReplyID",
          otherMenuOptionsForMessageItemsReducer.data._id
        );

        axios
          .post("/creatMessagerReply/api", formData)
          .then((response) => {
            console.log(response.data);
            console.log("creatmessa");
            dispatch(getMessageItem(`/getItemMessages/api?chatID=${chatID}`));
            setValue("");
            setSelectedFiles([]);
            setTimeout(() => {
              scrollToBottom();
            }, 2000);
            dispatch(enabledAll())
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    } catch (error) {
      console.error("Error:", error);
      throw new Error("ошибка при создании сообщения"); // Генерация ошибки при возникновении ошибки запроса
    }
  };

  const handleSendServer = async () => {
    if (
      otherMenuOptionsForMessageItemsReducer.editMessage == false &&
      otherMenuOptionsForMessageItemsReducer.replyMessage == false
    ) {
      handleCreateMessage();
    } else if (
      otherMenuOptionsForMessageItemsReducer.editMessage == true &&
      otherMenuOptionsForMessageItemsReducer.replyMessage == false
    ) {
      handleEdit();
    } else if (
      otherMenuOptionsForMessageItemsReducer.editMessage == false &&
      otherMenuOptionsForMessageItemsReducer.replyMessage == true
    ) {
      handleReply();
    }
  };


  // получение идентификатора пользователей этого чата
  function axiosGetWorkers(url) {
    axios
      .get(url)
      .then(function (response) {
        // handle success
        setChooseWokers([]);
        if (response.data.data) {
          const newChooseWokers = response.data.data.map(item => item.workerID);
          setChooseWokers(prevWorkers => [...prevWorkers, ...newChooseWokers]);
          const adminWorkerID = gerChekcedCompany?.rootReducer?.users?.adminInfo?.workerID;
          if (adminWorkerID) {
            setChooseWokers(prevWorkers => [...prevWorkers, adminWorkerID]);
          }

          if (newChooseWokers.length > 0 || adminWorkerID) {
            socket.emit("updateCreatMessage", [...newChooseWokers, adminWorkerID]);
          } else {
            alert("No workers found");
          }
        }
      })
      .catch(function (error) {
        // handle error
        console.error("Error fetching data:", error);
      });
  }


  return (
    <div
      className={
        getDarkModoe.ToggleDarkModeReducer.chekced
          ? "ChatBoxContDark"
          : "ChatBoxContLight"
      }
    >
      <div>
        <textarea
          className="extarea"
          ref={textareaRef}
          placeholder="Напишите сообщение"
          value={value}
          id="textarea"
          onChange={handleChange}
          onSelect={handleSelection}
          style={{ height }}
        ></textarea>

        <div className="imagesCont">
          {selectedFiles.map((item, index) => (
            <UploadFileItems
              key={index}
              item={item}
              handleDeleteInArray={handleDelete}
              index={index}
            />
          ))}
          {editfiles.map((item, index) => (
            <UploadFileItemsEdit
              key={index}
              item={item}
              handleDeleteInArray={handleDeleteFile}
              index={index}
            />
          ))}
        </div>
      </div>


      <div className="otherOptionContForChtatBox">
        <div className="otherButtons">
          <div>
            <label htmlFor="uploadFile">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="15"
                viewBox="0 0 11 15"
                fill="none"
              >
                <path
                  d="M7.11313 1.22776C7.53117 1.01996 8.02246 0.95813 8.50875 1.08843C9.567 1.37199 10.195 2.45974 9.91146 3.51799L8.29783 9.54012C8.01428 10.5984 6.92653 11.2264 5.86828 10.9428C4.81002 10.6593 4.18201 9.57152 4.46557 8.51327L5.11102 6.10442C5.18393 5.83229 5.02244 5.55259 4.75032 5.47967C4.4782 5.40676 4.19849 5.56825 4.12558 5.84037L3.48013 8.24922C3.05074 9.85171 4.00173 11.4989 5.60423 11.9283C7.20672 12.3577 8.85389 11.4067 9.28327 9.80417L10.8969 3.78204C11.3263 2.17954 10.3753 0.532378 8.7728 0.102991C8.03726 -0.0940951 7.2911 -7.98622e-06 6.659 0.314211C6.27141 0.506884 5.92589 0.782634 5.65075 1.12565C5.47448 1.34541 5.50973 1.66646 5.72949 1.84273C5.94925 2.019 6.2703 1.98375 6.44657 1.76399C6.62788 1.53795 6.85626 1.35545 7.11313 1.22776Z"
                  fill="#858C99"
                />
                <path
                  d="M2.70217 5.45896C2.98572 4.40071 4.07347 3.7727 5.13173 4.05626C6.18998 4.33982 6.81799 5.42757 6.53443 6.48582L5.88898 8.89467C5.81607 9.16679 5.97756 9.4465 6.24968 9.51941C6.5218 9.59233 6.80151 9.43084 6.87442 9.15872L7.51987 6.74987C7.94926 5.14737 6.99827 3.50021 5.39577 3.07082C3.79328 2.64143 2.14611 3.59242 1.71673 5.19492L0.103102 11.217C-0.326285 12.8195 0.624706 14.4667 2.2272 14.8961C2.96274 15.0932 3.7089 14.9991 4.341 14.6849C4.72859 14.4922 5.07412 14.2165 5.34925 13.8734C5.52552 13.6537 5.49027 13.3326 5.27051 13.1564C5.05075 12.9801 4.7297 13.0153 4.55343 13.2351C4.37212 13.4611 4.14374 13.6436 3.88687 13.7713C3.46884 13.9791 2.97754 14.041 2.49125 13.9107C1.433 13.6271 0.804984 12.5393 1.08854 11.4811L2.70217 5.45896Z"
                  fill="#858C99"
                />
              </svg>
              <input
                type="file"
                name=""
                style={{ display: "none" }}
                id="uploadFile"
                multiple
                onChange={handleFileChange}
              />
            </label>
          </div>
          <div>
            <label htmlFor="uploadImage">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.17949 3.28205C5.93331 3.28205 4.92308 4.29228 4.92308 5.53846C4.92308 6.78464 5.93331 7.79487 7.17949 7.79487C8.42567 7.79487 9.4359 6.78464 9.4359 5.53846C9.4359 4.29228 8.42567 3.28205 7.17949 3.28205ZM6.15385 5.53846C6.15385 4.97202 6.61304 4.51282 7.17949 4.51282C7.74593 4.51282 8.20513 4.97202 8.20513 5.53846C8.20513 6.10491 7.74593 6.5641 7.17949 6.5641C6.61304 6.5641 6.15385 6.10491 6.15385 5.53846Z"
                  fill="#858C99"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.6624 0.101521C10.7252 -1.19209e-05 9.54403 -6.59159e-06 8.03713 1.08584e-07H7.96287C6.45597 -6.59159e-06 5.27476 -1.19209e-05 4.33762 0.101521C3.38128 0.205133 2.60641 0.420369 1.94481 0.901048C1.54428 1.19205 1.19205 1.54428 0.901048 1.94481C0.420369 2.60641 0.205133 3.38128 0.101521 4.33762C-1.19209e-05 5.27476 -6.59159e-06 6.45597 1.08584e-07 7.96287V8.03713C-6.59159e-06 9.54403 -1.19209e-05 10.7252 0.101521 11.6624C0.205133 12.6187 0.420369 13.3936 0.901048 14.0552C0.911607 14.0697 0.922248 14.0842 0.932972 14.0986C1.21768 14.4812 1.55881 14.8185 1.94481 15.099C2.60641 15.5796 3.38128 15.7949 4.33762 15.8985C5.27474 16 6.45593 16 7.96279 16H8.03715C9.54401 16 10.7253 16 11.6624 15.8985C12.6187 15.7949 13.3936 15.5796 14.0552 15.099C14.4557 14.808 14.808 14.4557 15.099 14.0552C15.8127 13.0728 15.951 11.8192 15.9876 10.0517C16 9.45084 16 8.77152 16 8.0049V7.96285C16 6.45599 16 5.27474 15.8985 4.33762C15.7949 3.38128 15.5796 2.60641 15.099 1.94481C14.808 1.54428 14.4557 1.19205 14.0552 0.901048C13.3936 0.420369 12.6187 0.205133 11.6624 0.101521ZM2.66824 1.89676C3.08506 1.59392 3.61857 1.4174 4.47019 1.32513C5.33333 1.23161 6.44794 1.23077 8 1.23077C9.55206 1.23077 10.6667 1.23161 11.5298 1.32513C12.3814 1.4174 12.9149 1.59392 13.3318 1.89676C13.6278 2.11185 13.8882 2.37219 14.1032 2.66824C14.4061 3.08506 14.5826 3.61857 14.6749 4.47019C14.7684 5.33333 14.7692 6.44794 14.7692 8C14.7692 8.20922 14.7692 8.41071 14.769 8.60498C14.6821 8.53133 14.5998 8.46661 14.5188 8.40912C12.4913 6.96952 9.69442 7.35075 8.12613 9.28049C7.996 9.44062 7.87135 9.62818 7.73014 9.86205L7.62763 9.84154C6.7258 9.66107 6.17357 9.55056 5.65511 9.56157C4.26969 9.59099 2.96727 10.228 2.09348 11.3035C1.8716 11.5766 1.68433 11.8964 1.45839 12.3307C1.40191 12.0983 1.35813 11.8344 1.32513 11.5298C1.23161 10.6667 1.23077 9.55206 1.23077 8C1.23077 6.44794 1.23161 5.33333 1.32513 4.47019C1.4174 3.61857 1.59392 3.08506 1.89676 2.66824C2.11185 2.37219 2.37219 2.11185 2.66824 1.89676ZM13.8063 9.41266C14.0094 9.55685 14.2444 9.78281 14.7506 10.2877C14.7037 11.9048 14.5411 12.7291 14.1032 13.3318C13.8882 13.6278 13.6278 13.8882 13.3318 14.1032C12.9149 14.4061 12.3814 14.5826 11.5298 14.6749C10.6667 14.7684 9.55206 14.7692 8 14.7692C7.39134 14.7692 6.84996 14.7691 6.36464 14.7633L8.26717 11.3973C8.37381 11.2086 8.46644 11.0447 8.54915 10.9001C8.81128 10.4417 8.95299 10.2146 9.08126 10.0567C10.2404 8.63039 12.3077 8.34861 13.8063 9.41266ZM5.00273 14.6716C4.99409 14.6868 4.98618 14.7023 4.97897 14.718C4.79989 14.7064 4.63069 14.6923 4.47019 14.6749C3.61857 14.5826 3.08506 14.4061 2.66824 14.1032C2.48677 13.9714 2.31871 13.8225 2.16627 13.6589C2.62722 12.737 2.81778 12.3638 3.04873 12.0796C3.69457 11.2846 4.65724 10.8138 5.68124 10.7921C5.99703 10.7854 6.34613 10.8429 7.08448 10.9885L5.00273 14.6716Z"
                  fill="#858C99"
                />
              </svg>
              <input
                type="file"
                name=""
                style={{ display: "none" }}
                id="uploadImage"
                multiple
                onChange={handleFileChange}
              />
            </label>
          </div>
          <EmojiDropDownPicker setValue={setValue} value={value} />
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M8.55642 12.5562C10.2746 12.5562 11.6675 11.1633 11.6675 9.4451C11.6675 7.72688 10.2746 6.33398 8.55642 6.33398C6.8382 6.33398 5.44531 7.72688 5.44531 9.4451C5.44531 11.1633 6.8382 12.5562 8.55642 12.5562Z"
                stroke="#858C99"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.2 5.7995V9.7995C12.2 10.436 12.4529 11.0465 12.9029 11.4966C13.353 11.9466 13.9635 12.1995 14.6 12.1995C15.2365 12.1995 15.847 11.9466 16.2971 11.4966C16.7471 11.0465 17 10.436 17 9.7995V8.9995C16.9999 7.19392 16.389 5.44148 15.2666 4.02713C14.1443 2.61277 12.5764 1.61968 10.8181 1.20934C9.05978 0.798999 7.21435 0.995537 5.58188 1.767C3.94942 2.53846 2.62592 3.83947 1.82661 5.45848C1.0273 7.07749 0.79918 8.91929 1.17934 10.6844C1.5595 12.4495 2.52559 14.0341 3.92051 15.1805C5.31543 16.3269 7.05715 16.9678 8.86246 16.9988C10.6678 17.0299 12.4305 16.4493 13.864 15.3515"
                stroke="#858C99"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <DopDownEditText
            editText={editText}
            editTextLink={editTextLink}
            certainText={certainText}
          />
        </div>
        <button className="iconSvgCont" onClick={handleSendServer}>
          
          <svg
         style={{
          transform: otherMenuOptionsForMessageItemsReducer.editMessage ? 'rotate(-180deg)' : 'rotate(0deg)',
          transition: 'transform 0.3s ease-in-out',
        }}
        
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.62 19.1075L20.58 13.1235C21.228 12.8435 21.228 11.9315 20.58 11.6515L6.62 5.66751C6.092 5.43551 5.508 5.82751 5.508 6.39551L5.5 10.0835C5.5 10.4835 5.796 10.8275 6.196 10.8755L17.5 12.3875L6.196 13.8915C5.796 13.9475 5.5 14.2915 5.5 14.6915L5.508 18.3795C5.508 18.9475 6.092 19.3395 6.62 19.1075Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
